// Use the browser build for the legacy Webpack 4 application.
import MarkdownIt from 'markdown-it/dist/markdown-it';

const markdown = new MarkdownIt({ html: false, linkify: true });
const renderLink = markdown.renderer.rules.link_open || ((tokens, index, options, env, self) => self.renderToken(tokens, index, options));
markdown.renderer.rules.link_open = (tokens, index, options, env, self) => {
  tokens[index].attrSet('target', '_blank');
  tokens[index].attrSet('rel', 'noopener noreferrer');
  return renderLink(tokens, index, options, env, self);
};

export function renderUpdateMarkdown(value) {
  return markdown.render(typeof value === 'string' ? value : '');
}
